import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
class QuickFixBanner extends Component {
    render() {
        const { t, handleShowDetails, extension, options } = this.props;
        const files = options.files && Array.isArray(options.files)
            ? options.files
            : options && Array.isArray(options)
                ? options
                : [];
        const areIssuesPresent = options.issuesCount && options.issuesCount !== 0;
        const issuesCount = areIssuesPresent
            ? options.issuesCount
                ? Number(options.issuesCount)
                : 0
            : options.files.length === 1 && Array.isArray(options.files[0])
                ? options.files[0].length
                : options.files.length;
        const issuesCountFormatted = new Intl.NumberFormat(t('numberFormatLocale')).format(issuesCount);
        const isJs = extension === 'js';
        const isPhp = extension === 'php';
        return (_jsxs("span", { className: "quick-fix__banner", children: [_jsx("span", { className: "quick-fix__title", children: t('quickFixes', { issuesCount: issuesCountFormatted }) }), _jsx("br", {}), isJs ? t('ignoreGeneratedFilesJS') : '', isPhp ? t('ignoreGeneratedFilesPHP') : '', _jsx("button", { className: "btn btn-primary ml-md-3", title: t('showDetails'), onClick: () => handleShowDetails(files, issuesCount, extension), children: t('showDetails') })] }));
    }
}
export default withTranslation()(QuickFixBanner);
